<template>
  <comm-dialog title="溯源信息" ref="dialog" :show-fotter="false" >
    <template slot="content">
      <el-timeline class="contentMain">
        <el-timeline-item
            v-for="(item, index) in lineDataList"
            :key="index"
            :timestamp="item.createTime">
          <el-tag type="info" v-if="item.revokeStatus == 1">已撤销</el-tag>
          <span v-if="item.wareStatus===1">入库: {{item.warehouseName}} | </span>
          <span v-else-if="item.wareStatus===2">出库: {{item.dealerName}} | </span>
          <span v-else-if="item.wareStatus === 3">退货</span>
          <span v-else-if="item.wareStatus ===4">解绑</span>
          <span v-else-if="item.wareStatus === 6">更改代理商为：【{{item.dealerName}}】 | </span>
          <span> 操作人: {{item.createBy}}</span>
          <span v-if="item.handle&&item.isBox!==isBox">
             <span :class="item.isBox ? 'box' : 'pack'" style="padding-right: 0;">{{item.isBox ? '箱' : '盒' }}</span>{{item.handle}}
          </span>
        </el-timeline-item>
      </el-timeline>
    </template>
  </comm-dialog>
</template>
<script>
import {get} from "@/utils/request";
import CommDialog from "@/components/common/CommDialog.vue";

export  default {
  components: {CommDialog},
   data(){
     return {
       lineDataList: [],
       dialogShow: false,
       isBox: true
     }
   },
  methods:{
    show(handle){
      this.isBox=false;
      this.initList(handle)
    },
    initList(handle){
      get('/crk/app/pageLog',{handle:handle}).then(res=>{
        this.lineDataList=res;
        this.$refs.dialog.dialogShow=true
      })
    },
    showBox(handleId,handle){
      this.isBox=true;
      this.$refs.dialog.dialogShow=true
      get('/crk/app/boxLog',{boxId:handleId,handle:handle}).then(res=>{
        this.lineDataList=res;
      })
    },

  }
}
</script>
<style scoped>
.contentMain span {
  padding-right: 10px;
}
</style>
